import React from "react";
import { Mail, Check } from "lucide-react";
import { useRoom } from "@/context/RoomContext";
import { Button } from "@/components/ui/button";

export default function RoomInvitesBanner() {
  const { invites, acceptInvite, declineInvite } = useRoom();
  if (!invites || invites.length === 0) return null;
  return (
    <div className="mb-6 space-y-2" data-testid="room-invites-banner">
      <h3 className="font-semibold text-sm flex items-center gap-1.5">
        <Mail className="w-4 h-4 text-[hsl(var(--primary))]" /> Room invites ({invites.length})
      </h3>
      {invites.map((inv) => (
        <div key={inv.id} className="flex items-center justify-between gap-3 rounded-xl border border-[hsl(var(--primary))]/30 bg-[hsl(var(--primary))]/5 p-3 text-sm" data-testid={`banner-invite-${inv.id}`}>
          <span className="truncate"><b>{inv.from_name}</b> invited you to <b>{inv.game_cover} {inv.game_title}</b></span>
          <div className="flex gap-2 shrink-0">
            <Button size="sm" className="rounded-full h-8" onClick={() => acceptInvite(inv)} data-testid={`banner-accept-${inv.id}`}><Check className="w-3.5 h-3.5" /> Join</Button>
            <Button size="sm" variant="outline" className="rounded-full h-8" onClick={() => declineInvite(inv.id)}>Decline</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
